"use strict";

var uuid = null;
var _require = require('uuid'),
  v4 = _require.v4;
uuid = v4;
module.exports = uuid;